import React from 'react';
import { LogIn } from 'lucide-react';

interface LoginButtonProps {
  onClick: () => void;
  isDarkMode: boolean;
}

export const LoginButton: React.FC<LoginButtonProps> = ({ onClick, isDarkMode }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm transition-all shadow-md hover:shadow-lg active:scale-95 ${
        isDarkMode 
          ? 'bg-blue-600 text-white hover:bg-blue-700' 
          : 'bg-blue-500 text-white hover:bg-blue-600'
      }`}
      aria-label="Sign in"
    >
      <LogIn size={18} />
      <span>Sign In</span>
    </button>
  );
};
